import { EventEmitter, Injectable, OnDestroy } from "@angular/core";
import { SubSink } from "subsink";
import { I18NStorageService } from "./i18n-storage-service";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class I18nService implements OnDestroy {
  public onDictionaryReady = new EventEmitter();

  private subs = new SubSink();
  dictionary;
  dictionary$;
  constructor(
    private readonly i18nstorageService: I18NStorageService,
    private http: HttpClient
  ) {
    this.subs.add(
      (this.dictionary$ = this.i18nstorageService.dictionary.subscribe(
        (value) => {
          this.dictionary = value;
          this.onDictionaryReady.emit();
        }
      ))
    );
  }

  fetch(locale: string) {
    return this.http.get(`assets/api/langs/${locale.toLowerCase()}.json`);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  getTranslation(phrase: string): string {
    return this.dictionary && this.dictionary[phrase]
      ? this.dictionary[phrase]
      : this.getPlaceholderText(phrase);
  }

  private getPlaceholderText(key: string): string {
    return key && !this.isNum(key) ? key : key;
  }

  private isNum(val): boolean {
    return !isNaN(val);
  }

  getBrowserLocales(options = {}): any {
    const defaultOptions = {
      languageCodeOnly: false,
    };
    const opt = {
      ...defaultOptions,
      ...options,
    };
    const browserLocales =
      navigator.languages === undefined
        ? [navigator.language]
        : navigator.languages;
    if (!browserLocales) {
      return undefined;
    }
    return browserLocales.map(locale => {
      const trimmedLocale = locale.trim();
      return opt.languageCodeOnly
        ? trimmedLocale.split(/-|_/)[0]
        : trimmedLocale;
    });
  }
}


